import styled from 'styled-components';
import { Flex, themeGet } from '@packages/ui';

export const MessageBox = styled.div`
  padding: 24px;
  background: #fff;
  width: 400px;
  border-radius: 6px;
  box-sizing: content-box;
  margin: auto;
  margin-top: 40px;
  position: relative;
  -webkit-box-shadow: 0px 0px 9px 2px rgba(179, 179, 179, 1);
  -moz-box-shadow: 0px 0px 9px 2px rgba(179, 179, 179, 1);
  box-shadow: 0px 0px 9px 2px rgba(179, 179, 179, 1);
`;

export const ExitButtonContainer = styled(Flex)`
  width: 21px;
  height: 21px;
  position: absolute;
  right: 0px;
  top: -32px;
  cursor: pointer;
`;

export const StyledTitle = styled.div`
  font-family: ${themeGet.fonts('brand')};
  font-size: ${themeGet.fontSize(7)};
  font-weight: ${themeGet.fontWeight('semibold')};
  color: ${themeGet.colors('kilamanjaro')};
  text-align: center;
`;

export const StyledText = styled.div`
  font-family: ${themeGet.fonts('brand')};
  font-size: ${themeGet.fontSize(6)};
  font-weight: ${themeGet.fontWeight('normal')};
  color: ${themeGet.colors('kilamanjaro')};
  margin: 16px 0 16px 0;
`;

export const StyledUnderlay = styled.div`
  background-color: rgba(244, 243, 242, 0.8);
  position: fixed;
  z-index: ${themeGet.zIndex('OVERLAY', 9)};
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
`;

export const StyledCTAWrapper = styled(Flex)`
  width: 100%;
  margin: auto;
`;

export const StyledCTATile = styled(Flex)`
  flex-direction: column;
  margin: auto;
`;

export const StyledImageWrapper = styled(Flex)`
  &:hover {
    object-fit: cover;
    transition: transform 0.2s ease-out 0s;
    transform: scale(1.11, 1.11);
  }
`;

export const StyledImageText = styled(Flex)`
  color: ${themeGet.colors('kilamanjaro')};
  font-family: ${themeGet.fonts('brand')};
  font-size: ${themeGet.fontSize(6)};
  font-weight: ${themeGet.fontWeight('normal')};
  text-align: center;
  margin-top: 7px;
  &:hover {
    color: ${themeGet.colors('primary')};
    user-select: none;
    object-fit: cover;
    text-decoration: underline;
    transition: transform 0.2s ease-out 0s;
    transform: scale(1.11, 1.11);
  }
`;
